import React from 'react';
import BottomTabNavigationItem, {
  BottomNavigationItemProps,
} from '../BottomTabNavigationItem';

const BottomTabNavItemWatch = (
  props: Omit<BottomNavigationItemProps, 'icon'>,
) => {
  const {title = 'Watch', ...rest} = props;
  return <BottomTabNavigationItem icon="watch" title={title} {...rest} />;
};

export default BottomTabNavItemWatch;
